import type { LatLngTuple } from 'leaflet';

interface Coordinates {
  latitude: number | null;
  longitude: number | null;
}

export function getMapPosition({ latitude, longitude }: Coordinates): LatLngTuple | null {
  return latitude === null || longitude === null ? null : [latitude, longitude];
}
